export enum QueryKey {
  EditUserProfile = 'edit-user-profile',

  GetPlans = 'get-plans',

  GetPlansByFilter = 'get-plans-by-filter',

  GetPlan = 'get-plan',

  GetExercises = 'get-exercises',

  GetUserPrefExercises = 'get-user-pref-exercises',

  GetWorkouts = 'get-workouts',

  GetWorkout = 'get-workout',

  GetWorkoutFromPlan = 'get-workout-from-plan',

  GetFeed = 'get-feed',

  FinishWorkout = 'finish-workout',

  FinishWorkoutAward = 'finish-workout-award',

  EarlyExitWorkout = 'early-exit-workout',

  GetRecoverableWorkout = 'get-recoverable-workout',

  GetLoggedInUser = 'get-logged-in-user',

  GetUser = 'get-user',

  GetUsers = 'get-users',

  GetChats = 'get-chats',

  GetPosts = 'get-posts',

  GetSavedPosts = 'get-saved-posts',

  GetFollowedUsersPosts = 'get-followed-users-posts',

  GetGroupPosts = 'get-group-posts',

  GetStories = 'get-stories',

  GetAlerts = 'get-alerts',

  GetMutedUsers = 'get-muted-users',

  GetDefaultImages = 'get-default-images',

  GetGroups = 'get-groups',

  GetGroupsHistory = 'get-groups-history',

  GetGroup = 'get-group',

  GetPeopleYouMayKnow = 'get-people-you-may-know',

  SearchGroups = 'search-groups',

  SearchPlans = 'search-plans',

  GetLeaderboard = 'get-leaderboard',
}
